import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { ProductCategory } from "@/domain/product-category.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class ProductCategoryService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: ProductCategory): Promise<ProductCategory> => {
    return httpClient
      .request<ProductCategory>({
        url: `${this.urlApiBase}/product-category`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: ProductCategory): Promise<ProductCategory> => {
    return httpClient
      .request<ProductCategory>({
        url: `${this.urlApiBase}/product-category/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<ProductCategory> => {
    const url = `${this.urlApiBase}/product-category/${id}`;

    return httpClient
      .request<ProductCategory>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<ProductCategory>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/product-category${query}`;

    return httpClient
      .request<IPaginateVueTable<ProductCategory>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<ProductCategory[]> => {
    const url = `${this.urlApiBase}/product-category/list-active`;

    return httpClient
      .request<ProductCategory[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<ProductCategory> => {
    const url = `${this.urlApiBase}/product-category/${id}`;

    return httpClient
      .request<ProductCategory>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
